<template>
  <div id="cashback" class="main_white main left col-lg-10 col-md-10 col-xs-12">
    <div class="col-lg-7">
      <h1 class="cat_title">{{ cashback.options.page_title }}</h1>
      <h2>{{ cashback.options.title }}</h2>
      <div class="subtitle">{{ cashback.options.subtitle }}</div>

      <div class="cashback-inner">
        <Cashback/>
        <div class="cashback-content">
          <div v-if="cashback.points">
            <div class="points">צברת <b>{{ cashback.points }}</b> נקודות</div>
            <div>ששוות {{ pointsWorth }} ₪, אפשר לממש בקנייה הבאה</div>
          </div>
          <div v-else class="no-points-wrap">
            <div>
              <div class="no-points-title">אין כאן נקודות</div>
              <div>זה בדיוק הזמן להתחיל לצבור, כל נקודה שווה שקל!</div>
            </div>
            <router-link to="/" class="button">העגלה מחכה לי</router-link>
          </div>
        </div>
      </div>

      <div class="cashback-instructions">
        <h3>איך צוברים נקודות</h3>
        <div class="steps">
          <div class="step">
            <CashbackStep1/>
            <div>מזמינים בכרמלה</div>
          </div>
          <ArrowLeft class="arrow-left"/>
          <div class="step">
            <CashbackStep2/>
            <div>צוברים 3% מסך ההזמנה</div>
          </div>
          <ArrowLeft class="arrow-left"/>
          <div class="step">
            <CashbackStep3/>
            <div>מממשים נקודות</div>
            <span>* החל מיתרה של {{ cashback.options.minimum_points }} נקודות צבורות</span>
          </div>
        </div>
        <div v-html="cashback.options.content"></div>
        <div class="cashback-faq" v-if="cashback.options.faq">
          <div class="career_row toggleContainer" v-for="(faq, index) in cashback.options.faq" :key="index">
            <div class="career_top ease">
              <a href="javascript:void(0);" onclick="toggle(this)">
                {{ faq.title }}
                <span class="show_icon"></span>
              </a>
            </div>
            <div class="career_open toggleInner" v-html="faq.content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import Cashback from "@/assets/img/cashback-big.svg";
import CashbackStep1 from "@/assets/img/cashback-step1.svg";
import CashbackStep2 from "@/assets/img/cashback-step2.svg";
import CashbackStep3 from "@/assets/img/cashback-step3.svg";
import ArrowLeft from "@/assets/img/arrow-left.svg";

export default {
  data() {
    return {
      cashback: this.$store.state.cashback
    }
  },
  methods: {},
  computed: {
    ...mapGetters({pointsWorth: "getCashbackPointsWorth"}),
  },
  components: {
    Cashback,
    CashbackStep1,
    CashbackStep2,
    CashbackStep3,
    ArrowLeft
  },
};
</script>
<style lang="sass" scoped>
#cashback
  background: #fff url(../../assets/img/cashback-bg.jpg) repeat-y top left/32% auto

  h1
    font-size: 28px

  h2
    color: #1e824c
    font-family: 'raanancondensed', arial, sans-serif
    font-size: 48px

  .subtitle
    font-size: 36px
    color: #000
    font-family: 'raanancondensed', arial, sans-serif
    line-height: 28px

  .cashback-inner
    margin: 2em 0
    padding: 2em 0
    border: 0 dashed #1e824c
    border-width: 1px 0
    display: flex
    align-items: center
    column-gap: 15px

    svg
      fill: #1e824c
      margin-top: -15px

    .cashback-content
      flex: 1

      .points b
        font-size: 170%
        line-height: 1
        font-weight: 900
        padding: 0 3px
        color: #000

      .no-points-wrap
        display: flex
        justify-content: space-around
        align-items: flex-end

        @media (max-width: 480px)
          flex-direction: column
          align-items: flex-start
          gap: 10px

        .no-points-title
          font-size: 35px
          line-height: 1
          font-weight: 900
          color: #000

    .button
      margin-right: auto
      background-color: #EC593A
      color: #fff
      border-radius: 100px
      border: 0
      font-size: 16px
      padding: 10px 15px
      transition: 300ms ease all
      white-space: nowrap

      @media (max-width: 480px)
        margin-right: 0

      &:hover
        background-color: #ff2e00

  .cashback-instructions
    color: #252526

    h3
      font-weight: bold
      margin-bottom: 10px

    .steps
      display: flex
      column-gap: 20px
      align-items: flex-end
      margin: 1em -1em 2em 0

      .step
        text-align: center
        position: relative
        min-width: 134px

        div
          font-family: 'raanancondensed', arial, sans-serif
          font-size: 25px
          color: #1E824C

        span
          font-size: 12px
          color: #000
          display: block
          margin: -7px 0 -12px

      .arrow-left
        margin: auto 0

  .cashback-faq
    margin-top: 4em


</style>
